export abstract class Styling {
  public static readonly MIN_WIDTH = 1070;
  public static readonly MAX_WIDTH = 1400;
  public static readonly SCREEN_MD = 1024;
  public static readonly SCREEN_LG = 1200;
  public static readonly SCREEN_XL = 1400;
  public static readonly DEFAULT_BORDER_RADIUS = 3;
  public static readonly DEFAULT_SPACING = 12;
  public static readonly DEFAULT_SPACING_DOUBLED = Styling.DEFAULT_SPACING * 2;
  public static readonly DEFAULT_SPACING_HALVED = Styling.DEFAULT_SPACING / 2;
  public static readonly WIDEST_SOCIAL_ICON = 44;
  /* SOCIAL_ICON_SPACING is half of the widest icon (YouTube icon)
  (according to YouTube branding guidelines the space should be at least half of the icon width) */
  public static readonly SOCIAL_ICON_SPACING = Styling.WIDEST_SOCIAL_ICON / 2;
  public static readonly HEADER_FONT_SIZE = 14;
  public static readonly HEADER_HEIGHT = 64;
  /* Fixed rather than content-sized: the layout subtracts this exact value via the
     --impersonation-banner-height custom property, so the two must agree. */
  public static readonly IMPERSONATION_BANNER_HEIGHT = 32;
  public static readonly DEFAULT_WIDTH_1 = 20;
  public static readonly DEFAULT_WIDTH_2 = 30;
  public static readonly DEFAULT_LINEAR_PROGRESS_HEIGHT = 4;
}
